import { render, staticRenderFns } from "./ScalesComponent.vue?vue&type=template&id=219b6425"
import script from "./ScalesComponent.vue?vue&type=script&lang=js"
export * from "./ScalesComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports